var React = require('react');

function FileBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"fileblack_Path_380","data-name":"fileblack_Path 380","d":"M23.578,9.968a.776.776,0,0,0-.621-.31H20.628V8.1a.776.776,0,0,0-.776-.776H12.089V5.776A.776.776,0,0,0,11.313,5H2.775A.776.776,0,0,0,2,5.776V21.34A.605.605,0,0,0,2,21.5a.66.66,0,0,0,.047.132.419.419,0,0,0,.078.124.629.629,0,0,0,.093.109l.116.085a1.172,1.172,0,0,0,.14.07h0a.776.776,0,0,0,.3.054H20.038a.528.528,0,0,0,.155-.054.442.442,0,0,0,.1-.062l.132-.109a1.32,1.32,0,0,0,.078-.109.861.861,0,0,0,.07-.147s0,0,0-.047l3.1-10.867A.776.776,0,0,0,23.578,9.968ZM3.551,6.552h6.986V8.1a.776.776,0,0,0,.776.776h7.762v.776H6.027a.776.776,0,0,0-.776.551l-1.7,5.8ZM19.269,20.525H3.815L6.609,11.21H21.924Z","transform":"translate(-1.993 -5)","fill":"#1a1a1a"}));
}

FileBlack.defaultProps = {"width":"21.731","height":"17.077","viewBox":"0 0 21.731 17.077"};

module.exports = FileBlack;

FileBlack.default = FileBlack;
